import React from 'react';

const ProcessSectionContainer = (props) => {
  return <section style={{display: "flex", width:"100%", flex:"1"}}>{props.children}</section>;
}

export default ProcessSectionContainer;
